import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-3 rounded-xl border border-gray-100 bg-gray-50 px-4 py-3" }
const _hoisted_2 = { class: "flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-gray-100 bg-white text-lg text-gray-500" }
const _hoisted_3 = { class: "min-w-0" }
const _hoisted_4 = { class: "text-[11px] font-medium uppercase tracking-wide text-gray-500" }
const _hoisted_5 = { class: "text-sm font-semibold text-gray-900 break-words" }

import SVGIcon from '@/components/SVGIcon.vue'

/** Campo do detalhe do médico: ícone + rótulo + valor (slot), no card cinza das abas. */

export default /*#__PURE__*/_defineComponent({
  __name: 'DetailField',
  props: {
    icon: {},
    label: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _createVNode(SVGIcon, { path: _ctx.icon }, null, 8, ["path"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.label), 1),
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ]))
}
}

})